<button
  class="round-button"
  [ngStyle]="style"
  (click)="clickOnButton($event)">
  {{title}}
</button>